/**
 * Custom: belt-and-braces click-through for product thumbnail grids.
 *
 * These cards have their title/price hidden (see theme.liquid's
 * ".product-grid-container .card__content, .related-products .card__content
 * { display: none; }" rule), so we also render an invisible overlay link
 * over each thumbnail (snippets/card-product.liquid: <a
 * class="card__media-link">) to restore navigation to the product page.
 *
 * This script is an independent, JS-based fallback for the exact same
 * navigation, in case that overlay link ever fails to receive the click for
 * any reason (stacking/positioning edge case, browser quirk, etc). It listens
 * for clicks anywhere on a product thumbnail and navigates directly, without
 * depending on any absolutely-positioned overlay element actually being on
 * top and receiving the pointer event.
 *
 * Covers both places this card markup is used with the title/price hidden:
 * the main collection grid (.product-grid-container) and the "EXPLORE MORE"
 * related-products grid on product pages (.related-products) — the latter
 * was originally missed here, which is why its thumbnails weren't
 * click-through even though the collection grid's were.
 */
document.addEventListener('click', function (event) {
  var media = event.target.closest(
    '.product-grid-container .card__media[data-product-url], .related-products .card__media[data-product-url]'
  );
  if (!media) return;

  // Don't hijack a click that's already on a real interactive element
  // (defensive; these grids currently have no such elements inside the media box).
  if (event.target.closest('a, button, input, textarea, select, label')) return;

  var url = media.getAttribute('data-product-url');
  if (url) {
    window.location.href = url;
  }
});
